import React from "react";
import {
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  IconButton,
  ListItemButton,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { PdfModal } from "../Modal/PdfModal";
import { ImageDetailModal } from "../Modal/ImageDetailModal";
import { getImageSRC } from "../../functions/assets";
import getAttachmentAsset from "../../api/getAsset";

export function AttachmentListItem({ item }) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [source, setSource] = React.useState("");
  const [mimeType, setMimeType] = React.useState("");
  const [downloadUrl, setDownloadUrl] = React.useState(null);

  const closeModal = () => {
    setModalOpen(false);
    setSource("");
    setMimeType("");
  };

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const url = await getAttachmentAsset(item.filename);
        if (mounted) setDownloadUrl(url);
      } catch (e) {
        // silent fail
      }
    })();
    return () => {
      mounted = false;
    };
  }, [item.filename]);

  return (
    <React.Fragment>
      <ListItemButton
        onClick={() => {
          setModalOpen(true);
          setSource(getImageSRC(item.filename));
          setMimeType(item.mimeType);
        }}
      >
        <ListItemAvatar>
          <Avatar
            style={{ borderRadius: ".5rem" }}
            src={getImageSRC(item.previewFilename) + "&scalePercent=20"}
            alt={item.name}
          />
        </ListItemAvatar>
        <ListItemText primary={item.name} />
        <ListItemSecondaryAction>
          <IconButton
            edge="end"
            aria-label="download"
            download={item.filename}
            href={downloadUrl}
          >
            <CloudDownloadIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItemButton>

      {modalOpen && mimeType.includes("pdf") ? (
        <PdfModal source={source} closeModal={closeModal} />
      ) : modalOpen && mimeType.includes("image") ? (
        <ImageDetailModal
          imageSourceForModal={source}
          closeModal={closeModal}
        />
      ) : null}
    </React.Fragment>
  );
}
